angular.module('unica_media_directory.media_directory_services', []);